import type { DataOf } from '@elara/firebolt/shared';

import { collectionPath, defineModelSpec } from '@elara/firebolt/shared';

import { FlightOptionSchema } from './schemas/flight-schemas.js';
import { id, tripId } from './schemas/zod-types.js';

/**
 * The canonical ModelSpec for the flight-options subcollection within a trip.
 * It defines the path (`trips/{tripId}/flight-options/{id}`) and the data shape for a stored flight option document.
 * Flight options are persisted when fetchFlightData runs so shortlist and itinerary can reference them by id.
 */
export const FlightOptionModelSpec = defineModelSpec({
  path: collectionPath`trips/${tripId}/flight-options/${id}`,
  shape: FlightOptionSchema.shape,
});

export type FlightOptionModelSpec = typeof FlightOptionModelSpec;
export interface FlightOptionData extends DataOf<FlightOptionModelSpec> {}
